import type { GetVersionsRequest } from "@/generated/fastapi";

export const versioningKeys = {
  all: ["versions"] as const,
  list: (request: GetVersionsRequest = {}) =>
    [...versioningKeys.all, "list", request] as const,
};
